import {
	INIT_DETAILS_PAGE,
	INIT_DETAILS_PAGE_MODAL,
	SET_DETAILS_LOADING,
	SUBMIT_LOCATION,
	SUBMIT_LOCATION_MODAL,
} from '../actionTypes';

export const initDetailsPage = movePlanId => ({
	type: INIT_DETAILS_PAGE,
	payload: movePlanId,
});

export const initDetailsPageModal = movePlanId => ({
	type: INIT_DETAILS_PAGE_MODAL,
	payload: movePlanId,
});

export const submitLocation = values => ({
	type: SUBMIT_LOCATION,
	payload: values,
});

export const submitLocationModal = values => ({
	type: SUBMIT_LOCATION_MODAL,
	payload: values,
});

export const setDetailsLoading = bool => ({
	type: SET_DETAILS_LOADING,
	payload: bool,
});
